import { ShieldCheck, MessageSquare, X } from "lucide-react";

/**
 * VoiceConsentModal — shown before microphone activation.
 * Text is loaded from backend config so Ima can edit it in the Command Center.
 */
export default function VoiceConsentModal({ consentText, disclaimerText, onAccept, onSwitchToText, onClose }) {
  return (
    <div className="voice-consent" role="dialog" aria-modal="true" aria-label="Voice AURI consent" data-testid="voice-consent">
      <div className="voice-consent__panel">
        <button
          type="button"
          className="voice-consent__close"
          onClick={onClose}
          aria-label="Close"
          data-testid="voice-consent-close"
        >
          <X className="h-5 w-5" />
        </button>
        <div className="voice-consent__badge">
          <ShieldCheck className="h-4 w-4 text-altura-gold" />
          <span>Privacy &amp; Consent</span>
        </div>
        <h2 className="voice-consent__title">Talk to AURI</h2>
        <p className="voice-consent__lede">Your Global Investment Concierge · Powered by AURELIS Intelligence</p>
        <p className="voice-consent__text" data-testid="voice-consent-text">{consentText}</p>
        {disclaimerText ? <p className="voice-consent__disclaimer">{disclaimerText}</p> : null}
        <div className="voice-consent__actions">
          <button
            type="button"
            onClick={onAccept}
            className="btn-gold btn-compact voice-consent__cta"
            data-testid="voice-consent-accept"
          >
            Agree &amp; Continue
          </button>
          <button
            type="button"
            onClick={onSwitchToText}
            className="voice-consent__link"
            data-testid="voice-consent-switch-text"
          >
            <MessageSquare className="h-4 w-4" /> Continue with Text Instead
          </button>
        </div>
      </div>
    </div>
  );
}
